var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegrationBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(-174 -1896)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(174 1896)",
    fill: "#24397a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "integration_instructions-24px_1_",
    "data-name": "integration_instructions-24px (1)",
    transform: "translate(194 1916)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1052",
    "data-name": "Rectangle 1052",
    width: 40,
    height: 40,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(18.75 4.583)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(18.75 4.583)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499",
    "data-name": "Path 499",
    d: "M5,21.667v6.667H28.333V5H5Z",
    transform: "translate(3.333 3.333)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2660",
    "data-name": "Group 2660",
    transform: "translate(5 3.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M14.333,18.01l-3.617-3.617,3.617-3.617L11.983,8.41,6,14.393l5.983,5.983Z",
    transform: "translate(-1 3.94)",
    fill: "#fff",
    stroke: "#24397a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M15.35,20.377l5.983-5.983L15.35,8.41,13,10.777l3.617,3.617L13,18.01Z",
    transform: "translate(3.667 3.94)",
    fill: "#fff",
    stroke: "#24397a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_502",
    "data-name": "Path 502",
    d: "M29.667,4.333H22.7a4.98,4.98,0,0,0-9.4,0H6.333a2.92,2.92,0,0,0-.667.067,3.368,3.368,0,0,0-2.4,1.983A3.211,3.211,0,0,0,3,7.667V31a3.419,3.419,0,0,0,.267,1.3,3.532,3.532,0,0,0,.717,1.067,3.346,3.346,0,0,0,1.683.917,4.325,4.325,0,0,0,.667.05H29.667A3.343,3.343,0,0,0,33,31V7.667A3.343,3.343,0,0,0,29.667,4.333ZM18,3.917a1.25,1.25,0,1,1-1.25,1.25A1.259,1.259,0,0,1,18,3.917ZM29.667,24.333V31H6.333V7.667H29.667Z",
    transform: "translate(-3 -1)",
    fill: "#fff",
    stroke: "#24397a",
    strokeWidth: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationBg);
export default __webpack_public_path__ + "static/media/integration-bg.8cf08e7d64bed593d00fb46155b3a716.svg";
export { ForwardRef as ReactComponent };